import ArticleLayout from "@/pages/articles/components/ArticleLayout";

export default function BrendovyeTablitsyYoybuy() {
  return <ArticleLayout slug="brendovye-tablitsy-yoybuy" />;
}